import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 18px 0 8px;
`;

export const ButtonTheme = styled.button`
  position: fixed;
  top: 14px;
  right: 14px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 14px;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.22);
`;

export const LoginCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
  padding: 30px 24px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(20px);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.26),
    0 1px 0 rgba(255, 255, 255, 0.85) inset;

  &::before {
    content: '';
    position: absolute;
    top: -110px;
    right: -110px;
    width: 210px;
    height: 210px;
    border-radius: 999px;
    background: rgba(255, 109, 60, 0.12);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    left: -100px;
    bottom: -112px;
    width: 200px;
    height: 200px;
    border-radius: 48px;
    background: rgba(23, 137, 221, 0.08);
    transform: rotate(18deg);
    pointer-events: none;
  }

  > form,
  > div {
    position: relative;
    z-index: 1;
  }

  > form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  form > div {
    width: 100%;
  }

  form label {
    margin-bottom: 8px;
    color: #2c405a;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.7px;
    text-transform: uppercase;
  }

  form input {
    height: 52px;
    border: 1px solid rgba(216, 224, 235, 0.95);
    border-radius: 14px;
    color: #1f2f46;
    font-size: 15px;
    padding: 0 16px;
    outline: none;
    background: rgba(248, 250, 253, 0.92);
    transition: border-color 0.25s ease, box-shadow 0.25s ease,
      background 0.25s ease;

    &::placeholder {
      color: #97a3b5;
      font-size: 14px;
    }

    &:focus {
      border-color: #ff6d3c;
      background: #fff;
      box-shadow: 0 0 0 4px rgba(255, 109, 60, 0.12);
    }

    &.has-error {
      border-color: #de3b3b;
      box-shadow: 0 0 0 4px rgba(222, 59, 59, 0.1);
    }
  }

  form span.error {
    padding-top: 6px;
    color: #de3b3b;
    font-size: 11px;
    font-weight: 700;
  }

  button {
    cursor: pointer;
  }

  button#btn-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 54px;
    width: 100%;
    margin-top: 22px;
    border: 0;
    border-radius: 15px;
    color: #fff;
    background: linear-gradient(135deg, #ff6d3c, #ff875f);
    box-shadow: 0 16px 34px rgba(255, 109, 60, 0.34);
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 0.2px;
    transition: transform 0.25s ease, box-shadow 0.25s ease,
      background 0.25s ease;

    &:hover {
      transform: translateY(-1px);
      background: linear-gradient(135deg, ${shade(0.08, '#ff6d3c')}, #ff784a);
      box-shadow: 0 18px 38px rgba(255, 109, 60, 0.4);
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.72;
      transform: none;
      box-shadow: none;
    }
  }
`;

export const BrandLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  img {
    height: auto;
    width: 138px;
  }
`;

export const LoginHeader = styled.div`
  margin-bottom: 22px;

  > span {
    display: block;
    margin-bottom: 8px;
    color: #ff6d3c;
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  h1 {
    margin: 0;
    color: #17263b;
    font-size: 28px;
    line-height: 1.1;
    letter-spacing: -0.7px;
  }

  p {
    margin: 10px 0 0;
    color: #748196;
    font-size: 14px;
    line-height: 1.6;
  }
`;

export const LoginActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;

  button#btn-forgot {
    border: 0;
    background: transparent;
    color: #ff6d3c;
    font-size: 13px;
    font-weight: 800;
    transition: color 0.25s ease;

    &:hover {
      color: ${shade(0.18, '#ff6d3c')};
      text-decoration: underline;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a img {
    height: auto;
    width: 132px;
    opacity: 0.7;
    filter: brightness(0) invert(1);
  }
`;
